import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { MentionsInput, Mention } from "react-mentions";
import "./styles.scss";

export const MentionTextarea = ({ value, onChange, placeholder, className, users = [], maxLength, inputRef }) => {
  const mentionList = users ? users.map(u => ({ id: u._id, display: u.name })) : [];
  const renderSuggestion = (suggestion, search, highlightedDisplay, index, focused) => {
    return <div className={`user-mention ${focused ? "focused" : ""}`}>{highlightedDisplay}</div>;
  };

  const displayTransform = (id, display) => {
    return `@${display}`;
  };
  return (
    <MentionsInput
      value={value}
      onChange={onChange}
      className={`mentions-input ${className}`}
      allowSuggestionsAboveCursor
      placeholder={placeholder}
      maxLength={maxLength}
      inputRef={inputRef}
    >
      <Mention
        trigger="@"
        data={mentionList}
        renderSuggestion={renderSuggestion}
        className="mention-in-area"
        displayTransform={displayTransform}
        appendSpaceOnAdd
      />
    </MentionsInput>
  );
};

MentionTextarea.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  maxLength: PropTypes.string,
};

const mapStateToProps = state => ({
  users: state.client.users,
});

export default connect(mapStateToProps, null)(MentionTextarea);
